import { useEffect, useState } from "react";
import { navItems } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkBase =
    "px-3 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap";

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
            <i className="ri-bookmark-3-fill" />
          </span>
          <span
            className={`font-heading font-bold text-lg tracking-tight transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            桃花视频导航
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-0.5">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`${linkBase} ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#bookmark"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-bookmark-3-line" />
            收藏本页
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl transition-colors cursor-pointer ${
              scrolled || open
                ? "text-foreground-900 hover:bg-background-200"
                : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <div className="grid grid-cols-2 gap-1.5">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
          <a
            href="#bookmark"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 w-full px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-bookmark-3-line" />
            收藏本页
          </a>
        </div>
      )}
    </header>
  );
}